import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";

export default function AdminLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("rama_token", data.token);
      toast.success("Bienvenue.");
      nav("/admin");
    } catch { toast.error("Identifiants invalides"); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-stone-900 text-stone-50 flex flex-col">
      <div className="wrap py-8">
        <Link to="/" className="font-display text-xl">RAMA <span className="italic text-greige">DÉCO</span></Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-6">
        <form onSubmit={submit} className="w-full max-w-md bg-stone-800 p-10 rounded-sm">
          <div className="font-mono-caption text-greige mb-4">Back-office</div>
          <h1 className="font-display text-3xl">Connexion</h1>
          <div className="mt-8 space-y-6">
            <div>
              <label className="text-xs font-mono-caption text-stone-400 block mb-2">Email</label>
              <input data-testid="admin-email" type="email" required value={email} onChange={e => setEmail(e.target.value)} className="w-full py-3 border-b border-stone-600 bg-transparent focus:border-bordeaux outline-none" />
            </div>
            <div>
              <label className="text-xs font-mono-caption text-stone-400 block mb-2">Mot de passe</label>
              <input data-testid="admin-password" type="password" required value={password} onChange={e => setPassword(e.target.value)} className="w-full py-3 border-b border-stone-600 bg-transparent focus:border-bordeaux outline-none" />
            </div>
          </div>
          <button data-testid="admin-login-submit" disabled={loading} className="btn-primary mt-10 w-full justify-center">{loading ? "…" : "Se connecter"} <ArrowRight size={16} /></button>
        </form>
      </div>
    </div>
  );
}
